import { useStore } from 'react-redux';

export function useReduxState() {
    const store = useStore();
    const state = store.getState();
    return state;
}
